const actions = {
  GET_DASHBOARD_DATA: "GET_DASHBOARD_DATA",

  GET_DASHBOARD_DATA_SUCCESS: "GET_DASHBOARD_DATA_SUCCESS",

  GET_DASHBOARD_DATA_FAILED: "GET_DASHBOARD_DATA_FAILED",

  GET_CHART_DATA: "GET_CHART_DATA",

  GET_CHART_DATA_SUCCESS: "GET_CHART_DATA_SUCCESS",

  GET_CHART_DATA_FAILED: "GET_CHART_DATA_FAILED",

  getDashboardData: () => ({
    type: actions.GET_DASHBOARD_DATA,
  }),
  getDashboardDataSuccess: (data) => ({
    type: actions.GET_DASHBOARD_DATA_SUCCESS,
    payload: data,
  }),
  getDashboardDataFailed: (error) => ({
    type: actions.GET_DASHBOARD_DATA_FAILED,
    payload: error,
  }),

  getChartData: () => ({
    type: actions.GET_CHART_DATA,
  }),
  getChartDataSuccess: (data) => ({
    type: actions.GET_CHART_DATA_SUCCESS,
    payload: data,
  }),
  getChartDataFailed: (error) => ({
    type: actions.GET_CHART_DATA_FAILED,
    payload: error,
  }),
};

export default actions;
